/** Shared severity/status chip helpers for supplier exception screens (Supplier Profile
 * Exceptions tab + standalone Supplier Exceptions screen). Demo Mode only. */

import { SupplierExceptionSeverity, SupplierExceptionStatus } from '../../../../mocks/data/supplierProfileData';

export const EXCEPTION_SEVERITY_COLOR: Record<SupplierExceptionSeverity, 'error' | 'warning' | 'info' | 'default'> = {
  Critical: 'error',
  High: 'warning',
  Medium: 'info',
  Low: 'default',
};

export const EXCEPTION_STATUS_COLOR: Record<SupplierExceptionStatus, 'success' | 'warning' | 'default'> = {
  Open: 'warning',
  InProgress: 'warning',
  Waived: 'default',
  Resolved: 'success',
};

export const EXCEPTION_CATEGORY_LABEL: Record<string, string> = {
  MissingDocuments: 'Missing documents',
  ExpiredCertifications: 'Expired certifications',
  PendingRenewals: 'Pending renewals',
  PoorDeliveryPerformance: 'Poor delivery performance',
  PricingIssues: 'Pricing issues',
  CatalogueIssues: 'Catalogue issues',
  MissingSiteCoverage: 'Missing site coverage',
  SupplierRequestsAwaitingReview: 'Supplier requests awaiting review',
  BlockedSupplierStillAssigned: 'Blocked supplier still assigned',
  SupplierHasNoActiveCatalogue: 'Supplier has no active catalogue',
};
